/* eslint-disable import/prefer-default-export */
export const shipmentQueryKeys = {
  allShipments: () => ["shipment", "all"],
  exceptions: ["exceptions"],
  shipmentListing: (filters: any) => ["shipment", "list", filters],
  shipmentDetails: (id: string) => ["shipment", "detail", id],
  shipmentBasicDetails: (id: string) => ["shipment-basic", "detail", id],
  shipmentAttachments: (id: string) => ["shipment-attachments", "detail", id],
  shipmentGeoDataDetails: (id: string) => ["shipment-geodata", "detail", id],
  shipmentQuotationActionHistoryDetails: (id: string) => ["quotation-action-history", "detail", id],
  shipmentTrackingReferences: (id: string) => ["shipment-tracking-references", "detail", id],
  shipmentSchedule: (id: string) => ["shipment-schedule", "detail", id],
  deliveryStopsPod: (id: string) => ["shipment-delivery-stops-pod", "detail", id],
  podAttachmentBucketList: (filters: any) => ["pod-attachment-bucket", "list", filters],
  podBucketAttachments: (id: string) => ["shipment-pod-bucket-attachments", "detail", id],
};
